import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { addLocationAsync, updateLocationAsync } from '../../../redux/location/LocationAction';

import Spinner from '../../../components/Spinner';

const REVENUE_SPLIT = 'revenue_split';

const LocationInformation = ({ locationInfo, setLocationInfo }) => {
  const dispatch = useDispatch();

  const isAddingLocation = useSelector((state) => state.locations?.isAddingLocation);
  const isEditLocation = useSelector((state) => state.locations?.isEditLocation);

  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLocationInfo((prev) => ({ ...prev, [name]: name === REVENUE_SPLIT ? +value : value }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!locationInfo.name) newErrors.name = 'Location name is required';
    if (!locationInfo.first_name || !locationInfo.last_name) newErrors.first_name = 'Admin name is required';
    if (!locationInfo.admin_email) newErrors.admin_email = 'Admin email is required';
    if (!locationInfo.revenue_split) newErrors.revenue_split = 'Revenue split is required';
    else if (!/\S+@\S+\.\S+/.test(locationInfo.admin_email)) newErrors.adminEmail = 'Please enter a valid email';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    if (!isEditLocation) {
      // Handle empty middle name before dispatching
      const updatedLocationInfo = { ...locationInfo };

      // Remove middle_name from object if it's empty
      if (!locationInfo.middle_name?.trim()) {
        delete updatedLocationInfo.middle_name;
      }

      dispatch(addLocationAsync(updatedLocationInfo, setSuccessMessage, setLocationInfo, setErrors));
    } else if (isEditLocation) {
      dispatch(updateLocationAsync(locationInfo, setSuccessMessage, setLocationInfo, setErrors));
    }
  };

  return (
    <div className="location-information">
      {successMessage && <div className="success-message">{successMessage}</div>}

      <form onSubmit={handleSubmit}>
        {isAddingLocation ? (
          <Spinner />
        ) : (
          <>
            <div className="form-section">
              <div className="input-group">
                <h3 className="sub-heading">
                  Location Name<span className="required">*</span>
                </h3>
                <input
                  placeholder="Enter location name"
                  type="text"
                  name="name"
                  value={locationInfo.name}
                  className="input"
                  onChange={handleChange}
                  required
                />
                {errors.name && <span className="error">{errors.name}</span>}
              </div>

              <div className="input-group">
                <h3 className="sub-heading">
                  Admin First Name<span className="required">*</span>
                </h3>
                <input
                  placeholder="Enter admin's first name"
                  type="text"
                  name="first_name"
                  value={locationInfo.first_name}
                  className="input"
                  onChange={handleChange}
                  disabled={isEditLocation}
                  required
                />
                {errors.first_name && <span className="error">{errors.first_name}</span>}
              </div>

              <div className="input-group">
                <h3 className="sub-heading">Admin Middle Name(Optional)</h3>
                <input
                  placeholder="Enter admin's middle name"
                  type="text"
                  name="middle_name"
                  value={locationInfo.middle_name}
                  className="input"
                  onChange={handleChange}
                  disabled={isEditLocation}
                />
                {errors.last_name && <span className="error">{errors.last_name}</span>}
              </div>

              <div className="input-group">
                <h3 className="sub-heading">
                  Admin Last Name<span className="required">*</span>
                </h3>
                <input
                  placeholder="Enter admin's last name"
                  type="text"
                  name="last_name"
                  value={locationInfo.last_name}
                  className="input"
                  onChange={handleChange}
                  disabled={isEditLocation}
                  required
                />
                {errors.last_name && <span className="error">{errors.last_name}</span>}
              </div>

              <div className="input-group">
                <h3 className="sub-heading">
                  Revenue Split<span className="required">*</span>
                </h3>
                <input
                  placeholder="Enter your revenue split percentage"
                  type="number"
                  name={REVENUE_SPLIT}
                  value={locationInfo.revenue_split}
                  className="input"
                  onChange={handleChange}
                  min="0"
                  max="100"
                  step="0.01"
                  required
                />
                {errors.revenue_split && <span className="error">{errors.revenue_split}</span>}
              </div>

              <div className="input-group">
                <h3 className="sub-heading">
                  Admin Email<span className="required">*</span>
                </h3>
                <input
                  placeholder="Enter admin email"
                  type="email"
                  name="admin_email"
                  value={locationInfo.admin_email}
                  className="input"
                  onChange={handleChange}
                  disabled={isEditLocation}
                  required
                />
                {errors.admin_email && <span className="error">{errors.admin_email}</span>}
              </div>
              {errors.detail && <span className="error">{errors.detail}</span>}
            </div>

            <div className="button-container">
              <button type="submit" className="submit-button">
                {isEditLocation ? 'Update Location' : 'Add Location'}
              </button>
            </div>
          </>
        )}
      </form>
    </div>
  );
};

export default LocationInformation;
